export const pcamStyles = {
	header: {
		backgroundColor: '#161616',
	},
	sidebar: {
		backgroundColor: '#161616',
		color: 'white',
	},
	button: {
		backgroundColor: '#d91e37',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#d91e37',
		},
	},
	title: {
		color: '#fff',
	},
	text: {
		color: '#161616',
		buttonLoadingColor: '#ff4141ff',
	},
	table: {
		headerBackgroundColor: '#085694',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'Parking Company of America Platform',
	},
	logo: {
		small: {
			src: '/pcam/parkpca-logo.png',
			height: 40,
			width: 45,
		},
		large: {
			src: '/pcam/parkpca-logo.png',
			height: 60,
			width: 100,
		},
	},
	favicon: {
		src: '/pcam/parkpca-logo.png',
	},
	socials: {
		instagram: 'https://instagram.com/pcaparking',
		facebook: 'https://www.facebook.com/parkingcompanyofamerica',
		linkedIn: 'https://www.linkedin.com/company/pcam-llc-parking-company-of-america-/',
	},
	siteUrl: 'http://parkpca.com/',
	orgName: 'Parking Company Of America',
};
